import React from 'react'
import { motion } from 'motion/react'
import DropIndicator from './DropIndicator'
import type { CardType } from '@univdiam/ui/type'
import { Separator } from '@univdiam/ui/components/separator'
import { Badge } from '@univdiam/ui/components/badge'
import { normalizeUrl } from '@univdiam/ui/lib/UrlNormalize'
import { labelStyle, type TagLike } from '@univdiam/ui/lib/tagColors'
import DueDateChip from '../DueDateChip'



type CardProps = {
  data: CardType,
  handleDragStart: (
    e: MouseEvent | TouchEvent | PointerEvent,
    card: CardType
  ) => void,
  handleOrderOpen: (id: string, customer_id: string, order_ref: string) => void,
  isDrag: boolean
  isAdmin?: boolean
  adminTags?: TagLike[]
}

const default_link = 'https://univdiam.nyc3.digitaloceanspaces.com/uploads/1/1759738306620-pawel-czerwinski-buv0JiMwEMk-unsplash.jpg'

const getCorrectAction = (type?: string) => {
  if (type === 'additional_instruction_added') {
    return 'Instructions added'
  } else if (type === 'additional_instruction_updated') {
    return 'Instructions updated'
  } else if (type === 'additional_instruction_deleted') {
    return 'Instructions deleted'
  } else if (type === 'cad_added') {
    return 'CAD added'
  } else return ''
}

const Card: React.FC<CardProps> = ({ data, handleDragStart, handleOrderOpen, isDrag, isAdmin, adminTags = [] }) => {
  const imageAttachment = data?.media_attachment?.find((file) => {
    const ext = file.split(".").pop()?.toLowerCase();
    return ["jpg", "jpeg", "png", "gif", "webp", "svg"].includes(ext!);
  });
  // console.log('imageAttachment', imageAttachment)
  return (
    <>
      <DropIndicator beforeId={String(data.id)} column={data.column} />
      <motion.div
        layout
        layoutId={String(data.id)}
        draggable="true"
        onDragStart={(e) => handleDragStart(e, data)}
        className={`cursor-pointer ${isDrag && "cursor-grab active:cursor-grabbing"} rounded-[4px] border border-[#E9EAEB] bg-white p-[8px] hover:bg-[#883734]/10 transition-colors duration-200 ${data.is_new_update && 'border border-black/40 shadow'}`}
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          handleOrderOpen(data.id.toString(), data.customer_id.toString(), data.order_id)
        }}
      >
        <div className='flex items-center gap-[8px]'>
          {
            data.labels.slice(0, 1).map(l => <p key={l} className='px-[8px] py-[4px] rounded-[100px] text-caption2 font-[700]' style={labelStyle(l, adminTags)}>{l}</p>)
          }
          {
            data.labels.length > 1 && <p className='text-secondary bg-[#F6F6F6] px-[8px] py-[4px] rounded-[100px] text-caption2 font-[700]'>+{data.labels.length - 1}</p>
          }

          {isAdmin && <DueDateChip value={data.due_date} className='ms-auto' />}
        </div>
        {
          <div className='mt-[8px] rounded-[4px] max-h-[92px] overflow-hidden border relative'>
            {
              data?.chat?.unread_count ? <p className='px-1.5 py-0.75 text-caption2 rounded-[4px] flex gap-1 items-center mt-2 w-fit text-xs font-bold text-black border border-[#CFCFD1] rounded-sm absolute text-black bg-white right-3'>{data?.chat?.unread_count} new message</p> : null
            }

            <img src={normalizeUrl(imageAttachment ? imageAttachment : default_link)} alt="" className="h-full w-full object-cover rounded-[4px]" />
          </div>
        }

        <p className='text-caption2 font-[500] mt-[8px]'>#{data.order_id}</p>
        {
          isAdmin && <p className='text-caption2 font-[500] mt-[8px] font-semibold'>Created by {data.c_business_name}</p>
        }

        <Separator className='my-1' />
        <p className="text-body2 mt-[8px]">{data.job_title}</p>
        <p className='text-caption2 mt-[8px] font-[500]'><span>{data.product_type}</span> {data.size && "|"} <span>{data.size}</span> {data.metal_type && "|"} <span>{data.metal_type}</span></p>
        {/* {
          (data?.activity_type === 'additional_instruction_added' || data?.activity_type === 'additional_instruction_updated' || data?.activity_type === 'additional_instruction_deleted' || data?.activity_type === 'cad_added') && <Badge
            variant='outline'

            className='px-1.5 py-0.75 text-caption2 rounded-[4px] flex gap-1 items-center mt-2 bg-[#883734] text-white'
          >
            Action required: {getCorrectAction(data.activity_type)}
          </Badge>
        } */}
        {/* {
          data?.chat?.unread_attention_messages?.map((m:{id:string, message:string}) => <Badge
            key={m.id}
            variant='outline'

            className='px-1.5 py-0.75 text-caption2 rounded-[4px] flex gap-1 items-center mt-2 bg-[#883734] text-white'
          >
            Attention required: {m.message}
          </Badge>)
        } */}
        {/* {
          data?.chat?.unread_attention_messages?.length((m:{id:string, message:string}) => <Badge
            key={m.id}
            variant='outline'

            className='px-1.5 py-0.75 text-caption2 rounded-[4px] flex gap-1 items-center mt-2 bg-[#883734] text-white'
          >
            Attention required: {m.message}
          </Badge>)
        } */}
        {
          data?.chat?.unread_attention_messages?.length > 0 && <Badge
            variant='outline'
            className='px-1.5 py-0.75 text-caption2 rounded-[4px] flex gap-1 items-center mt-2 bg-[#883734de] text-white'
          >
            {data?.chat?.unread_attention_messages?.length} Attention required
          </Badge>
        }
      </motion.div>
    </>
  )
}

export default Card
